(function() {
  if (window.PlumeBeforeAfter && window.PlumeBeforeAfter.init) {
    window.PlumeBeforeAfter.init(document);
    return;
  }

  function init(root) {
    (root || document).querySelectorAll('[data-plume-before-after-slider]').forEach(function(slider) {
      if (slider.getAttribute('data-plume-before-after-ready') === 'true') return;

      var reveal = slider.querySelector('[data-plume-before-after-reveal]');
      var handle = slider.querySelector('[data-plume-before-after-handle]');
      var active = false;
      if (!reveal || !handle) return;

      slider.setAttribute('data-plume-before-after-ready', 'true');

      function setPercent(value) {
        value = Math.max(0, Math.min(100, value));
        var clip = 'inset(0 0 0 ' + value + '%)';
        reveal.style.clipPath = clip;
        reveal.style.webkitClipPath = clip;
        handle.style.left = value + '%';
        handle.setAttribute('aria-valuenow', Math.round(value));
      }

      function setPosition(clientX) {
        var rect = slider.getBoundingClientRect();
        if (!rect.width) return;
        setPercent(((clientX - rect.left) / rect.width) * 100);
      }

      function getClientX(event) {
        var touch = event.touches && event.touches[0] || event.changedTouches && event.changedTouches[0];
        return touch ? touch.clientX : event.clientX;
      }

      function start(event) {
        active = true;
        setPosition(getClientX(event));
        if (event.cancelable) event.preventDefault();
      }

      function move(event) {
        if (!active) return;
        setPosition(getClientX(event));
        if (event.cancelable) event.preventDefault();
      }

      function stop() {
        active = false;
      }

      setPercent(parseInt(handle.getAttribute('aria-valuenow'), 10) || 50);
      slider.addEventListener('mousedown', start);
      slider.addEventListener('touchstart', start, { passive: false });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: false });
      window.addEventListener('mouseup', stop);
      window.addEventListener('touchend', stop);
      window.addEventListener('touchcancel', stop);

      handle.addEventListener('keydown', function(event) {
        var value = parseInt(handle.getAttribute('aria-valuenow'), 10) || 50;
        if (event.key === 'ArrowLeft') value -= 5;
        else if (event.key === 'ArrowRight') value += 5;
        else if (event.key === 'Home') value = 0;
        else if (event.key === 'End') value = 100;
        else return;

        setPercent(value);
        if (event.cancelable) event.preventDefault();
      });
    });
  }

  window.PlumeBeforeAfter = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
